export const ru = {
    details: 'Подробности',
    'paid_by_the_company:': 'Оплачивает компания ',
    'paid_by_you:': 'Оплачиваете вы ',
    'additional_services:': 'Дополнительные услуги ',
};
